import produce from "immer";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { uuid } from "uuidv4";
import { startEditElement } from "../../../../actions/elementListAction";
import { Element } from "../../../../models/elementModel";
import { NavigationDropdownList } from "../../../../models/NavgationDropdownModel";
import NavigationDropdownSecondLevelProperties from "./navigationDropdownSecondLevelProperties";
import Switch from "react-switch";
import { HiDocumentRemove } from "react-icons/hi";
import { Accordion, Button, Card } from "react-bootstrap";
import "../elementProprtiesPanal.scss";
export interface NavigationDorpdownProps {
  index: number;
  element: Element;
}

const NavigationDropdownProperties: FC<NavigationDorpdownProps> = ({
  element,
  index,
}) => {
  const dispatch = useDispatch();
  const addNewOption = () => {
    let newTab: NavigationDropdownList = {
      id: uuid(),
      name: "New Dropdown",
      isDropdown: false,
      dropdown: [],
      alignRight: false,
    };
    const newElement = produce(element, (draft) => {
      draft.properties.tabs[index].dropdown.push(newTab);
    });
    dispatch(startEditElement(newElement));
  };

  const removeOption = (i: number) => {
    const newElement = produce(element, (draft) => {
      draft.properties.tabs[index].dropdown.splice(i, 1);
    });
    dispatch(startEditElement(newElement));
  };
  return (
    <Accordion defaultActiveKey="1">
      <Card className="theam-component ml-0 mr-0">
        <Accordion.Toggle
          as={Button}
          variant="outline-dark"
          className="theam-font align-text-left"
          eventKey="1"
        >
          <div className="row">
            <div className="col-sm-10">Navigation Dropdown Properties</div>
            <div className="col-sm-2">
              <i
                className="fa fa-plus"
                onClick={(e) => {
                  e.stopPropagation();
                  addNewOption();
                }}
              ></i>
            </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="1">
          <Card.Body className="p-0">
            {element.properties.tabs[index].dropdown.map(
              (dropdown: NavigationDropdownList, i: number) => {
                return (
                  <div className="card theam-component" key={"firstLevel" + i}>
                    <div
                      className=""
                      id={"generalDropdown" + i}
                      style={{ backgroundColor: "#F9FBB1" }}
                    >
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark btn-block theam-component theam-font border-radius-0 collapsed"
                          data-toggle="collapse"
                          data-target={"#iddrp" + i.toString()}
                          aria-expanded="false"
                          aria-controls={"iddrp" + i.toString()}
                        >
                          <div className="row">
                            <div className="col-sm-10">
                              {"Level 1 - Property " + (i + 1)}
                            </div>
                            <div className="col-sm-2">
                              <HiDocumentRemove onClick={(e) => {
                                e.stopPropagation();
                                removeOption(i);
                              }}/>
                            </div>
                          </div>
                        </button>
                      </h5>
                    </div>
                    <div
                      id={"iddrp" + i.toString()}
                      className="collapse show"
                      aria-labelledby={"generalDropdown" + i}
                    >
                      <div className="card-body theam-card p-0 pt-3">
                        <div className="form-group row">
                          <label
                            htmlFor="lvl1drop"
                            className="col-sm-4 col-form-label font-size-12 align-text-left"
                          >
                            Dropdown
                          </label>
                          <div className="col-sm-5 text-align-justify remove-left-padding mt-2">
                            <Switch
                              checked={dropdown.isDropdown}
                              onChange={(e) => {
                                const newElement = produce(element, (draft) => {
                                  draft.properties.tabs[index].dropdown[
                                    i
                                  ].isDropdown = e;
                                  {
                                    draft.properties.tabs[index].dropdown[i]
                                      .isDropdown == false &&
                                      (draft.properties.tabs[index].dropdown[
                                        i
                                      ].dropdown = []);
                                  }
                                });
                                dispatch(startEditElement(newElement));
                              }}
                              onColor="#86d3ff"
                              onHandleColor="#2693e6"
                              handleDiameter={15}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={10}
                              width={24}
                              className="react-switch"
                              id="lvl1drop"
                            />
                          </div>
                          <div className="col-sm-3 mt-1 ml-30 align-text-right ">
                          </div>
                        </div>
                        <div className="form-group row mb-0 pb-1">
                          <label
                            htmlFor="dropdownName"
                            className="col-sm-4 col-form-label font-size-12 align-text-left"
                          >
                            Label
                          </label>
                          <div className="col-sm-8 remove-left-padding">
                            <input
                              value={dropdown.name.toString()}
                              className="form-control theam-textbox"
                              onChange={(e) => {
                                const newElement = produce(element, (draft) => {
                                  draft.properties.tabs[index].dropdown[
                                    i
                                  ].name = e.target.value;
                                });
                                dispatch(startEditElement(newElement));
                              }}
                              type="text"
                              id="dropdownName"
                            />
                          </div>
                        </div>
                        {dropdown.isDropdown == true && (
                          <NavigationDropdownSecondLevelProperties
                            element={element}
                            index={index}
                            index2={i}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default NavigationDropdownProperties;
